<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">In <i>Today I Remember</i>, Martin L. Shoemaker—award-winning author of <i>Today I Am Carey</i> and <i>The Last Dance</i>—shares stories written as tributes to the people who inspired him in his life and his writing.</p>
<ul>
<li>A circus acrobat relives tragedy and triumph</li>
<li>Leonardo da Vinci’s greatest creation exceeds even his vision</li>
<li>A manager must save a space colony from starvation</li>
<li>An Alzheimer’s patient and her android caretaker experience life through her delusions</li>
<li>A girl must keep her father alive after an accident on the Moon</li>
<li>A Lunar rescue squad races to find a lost transport ship</li>
<li>A vampire’s assistant must help him to face the great detective</li>
<li>A young man in Nigeria talks with the spirit of the wood</li>
<li>A dying patient volunteers for an experiment with unforeseen side-effects</li>
<li>A teacher must teach her students to survive the wreck of their spaceship</li>
<li>A young law student returns to Haiti to rescue his dead grandfather from the bokor</li>
</ul>
<p class="subsq">Each story begins with an explanation of how it came to be and who inspired it. These are some of Martin’s best stories—and best memories.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bookdescription.vue?17847424